import {ColumnsType} from 'antd/lib/table';
import {Tag} from 'antd';
import {styled} from 'styled-components';
import {tagColors} from '../../../../../utils/const';

interface TopPositionsColumnsProps {
	inventedCategories: Array<{text: string; value: string}>;
	categoriesNames: Array<{text: string; value: string}>;
}

export const ColumnTopPositions = ({
	inventedCategories,
	categoriesNames,
}: TopPositionsColumnsProps): ColumnsType => {
	return [
		{
			title: 'Локальные категории',
			dataIndex: 'name_invented',
			key: 'name_invented',
			render: (tag: string) => (
				<span>
					<Tag
						color={
							tag && tag.length > 0
								? tag.length > 24
									? 'red'
									: tagColors[tag.length]
								: 'blue'
						}
						key={tag}
					>
						{tag && tag.toUpperCase()}
					</Tag>
				</span>
			),
			filters: inventedCategories,
			onFilter: (value, record) => record?.name_invented === value,
			width: 100,
		},
		{
			title: 'Категория',
			dataIndex: 'CATEGORY',
			key: 'CATEGORY',
			render: (tag: string) => (
				<span>
					<Tag
						color={
							tag && tag.length > 10
								? tag && tag.length > 15
									? 'volcano'
									: 'cyan'
								: tag && tag.length < 7
								? 'green'
								: 'blue'
						}
						key={tag}
					>
						{tag && tag.toUpperCase()}
					</Tag>
				</span>
			),
			filters: categoriesNames,
			onFilter: (value, record) =>
				String(record.CATEGORY).toLowerCase() === String(value).toLowerCase(),
			width: 100,
		},
		{
			title: 'Наименование',
			dataIndex: 'NAME',
			key: 'NAME',
			render: (name: string) => <span>{name}</span>,
			width: 100,
		},
		{
			title: 'Количество',
			dataIndex: 'QUANTITY',
			key: 'QUANTITY',
			render: (quantity: number) => (
				<StyledSum>{new Intl.NumberFormat('ru-RU').format(Number(quantity))}</StyledSum>
			),
			width: 100,
			sorter: (a, b) => a.QUANTITY - b.QUANTITY,
		},
		{
			title: 'Сумма',
			dataIndex: 'SUMM',
			key: 'QUANTITY',
			render: (quantity: number) => {
				return (
					<StyledSum>
						{quantity ? new Intl.NumberFormat('ru-RU').format(Number(quantity)) : 0}
					</StyledSum>
				);
			},
			width: 100,
			sorter: (a, b) => a.SUMM - b.SUMM,
		},
	];
};

const StyledSum = styled.div`
	text-align: right;
	padding-right: 20%;
`;
